import 'src/pages/RSVPFormPage/RSVPFormPage.scss'

import { FC, useEffect } from 'react'
import { ReactComponent as CloseIcon } from 'src/components/App/images/close-icon.svg'
import { RSVPForm } from 'src/components/RSVPForm/RSVPForm'

const RSVPFormPage: FC = () => {
  useEffect(() => {
    document?.querySelector('html')?.classList.remove('html-scroll')
    window.scroll(0,0)
  }, [])

  const handleOnClickBack = () => {
    window.location.href = '/';
  }

  return (
    <main className='main'>
      <div className='form-page'>
        <button type='button' onClick={handleOnClickBack} className='form-page-close-button'>
          <CloseIcon />
        </button>
        <RSVPForm />
      </div>
    </main>
  )
}
export default RSVPFormPage
